// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"381":"af307b4c","404":"d8f6b995","524":"65ea27a5"}[chunkId] + ".js";
};